'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
var theme_common_tokens_breakpoints = require('../common/tokens/breakpoints.js');
var theme_CoreTheme_coreTheme = require('./coreTheme.js');
var react = require('@emotion/react');
var Provider = require('../../Provider-65b63bd9.js');
require('@babel/runtime/helpers/toConsumableArray');
require('@babel/runtime/helpers/defineProperty');
require('../common/primitives/defaultPrimitives.js');
require('../common/primitives/commonPrimitives.js');
require('../common/getTheme.js');
require('../common/tokens/borders.js');
require('../common/tokens/typography.js');
require('../common/tokens/spacing.js');
require('./olxPalette.js');
require('../../createStoreProvider-55b8195c.js');
require('@babel/runtime/helpers/slicedToArray');
require('../../DialogContext-26c9ead4.js');
require('lodash/fp/without');
require('../../SnackbarContext-45575d8a.js');
require('../../useMatchMedia-1f69f0f1.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);

var _excluded = ["children", "theme", "override"];
var CoreThemeProvider = function CoreThemeProvider(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? theme_CoreTheme_coreTheme.theme : _ref$theme,
    _ref$override = _ref.override,
    override = _ref$override === void 0 ? {} : _ref$override,
    restProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  var isValidTheme = theme !== undefined;
  return isValidTheme ? react.jsx(Provider.Provider, _extends__default["default"]({
    theme: _objectSpread__default["default"](_objectSpread__default["default"]({}, theme), {}, {
      media: theme_common_tokens_breakpoints.commonMedia
    }, override)
  }, restProps), children) : null;
};
CoreThemeProvider.displayName = 'ThemeProvider';

exports["default"] = CoreThemeProvider;
//# sourceMappingURL=CoreThemeProvider.js.map
